import React, { useState } from "react";
import GuardLayout from "./guard";
//import logo from "../assets/img/logo-white.png";
import logo from "../assets/img/newlogo.jpg";

import logo2 from "../assets/img/logo-white2.png";

//import logo3 from "../assets/img/logo-black.png";
import logo3 from "../assets/img/newlogo.jpg";

import logo4 from "../assets/img/logo-black2.png";

import { IoMenu } from "react-icons/io5";
import { RiNotification2Line } from "react-icons/ri";
import { FaRegUserCircle, FaUser, FaUserFriends, FaCity, FaCalendarAlt } from "react-icons/fa";
import { appRoutes, useAppNavigation } from "../router/routes";
import {
  FaHome,
  FaSignOutAlt,
  FaHandsHelping,
  FaMountainCity,
  FaFileAlt,
} from "react-icons/fa";
import { storageApi } from "../storage/storageApi";
import { ApiEndpoints, useApiCall } from "../api";
import { useRoleSelector } from "../helper/roleHelper";
import { UserRoles } from "../storage/enums";
import { MdOutlineRealEstateAgent } from "react-icons/md";
import { MdCollectionsBookmark } from "react-icons/md";
import { GoOrganization } from "react-icons/go";
import { TbCirclesRelation } from "react-icons/tb";
import { MdLocalActivity } from "react-icons/md";
import { RiMiniProgramFill } from "react-icons/ri";
import { MdOutlineSubtitles } from "react-icons/md";
import { MdOutlineSubject } from "react-icons/md";
import { FaClipboardQuestion } from "react-icons/fa6";

const MainLayout = ({ children }) => {
  const { navigate } = useAppNavigation();
  const logoutUser = storageApi.useLogout();

  const [showMenu, setShowMenu] = useState(false);
  const [showProfileDropDown, setShowProfileDropDown] = useState(false);

  const mainMenuItems = useRoleSelector(
    {
      [UserRoles.User]: [
        {
          name: "خانه",
          Icon: FaHome,
          route: appRoutes.dashboard,
        },
        {
          name: "صفحه اصلی",
          Icon: FaHome,
          route: "https://defadoc.ir",
          isLink: true,
        },
        {
          name: "حساب کاربری",
          Icon: FaUser,
          route: appRoutes.profile,
        },
        {
          name: "ارتباط‌ با ما",
          Icon: FaFileAlt,
          route: appRoutes.contactUs,
        },
        {
          name: "سابقه سامانه ۱۴۰۴",
          Icon: FaCalendarAlt,
          route: "https://1404.defadoc.ir",
          target: "_blank",
        },
        {
          name: "راهنما",
          Icon: FaHandsHelping,
          route: appRoutes.guide,
        },
      ],
      [UserRoles.Sazman]: [
        {
          name: "خانه",
          Icon: FaHome,
          route: appRoutes.dashboard,
        },
        {
          name: "صفحه اصلی",
          Icon: FaHome,
          route: "https://defadoc.ir",
          isLink: true,
        },
        {
          name: "حساب کاربری",
          Icon: FaUser,
          route: appRoutes.profile,
        },
        {
          name: "مدیریت کاربران",
          Icon: FaUserFriends,
          route: appRoutes.userList,
        },
        {
          name: "ارتباط‌ با ما",
          Icon: FaFileAlt,
          route: appRoutes.contactUs,
        },
        {
          name: "سابقه سامانه ۱۴۰۴",
          Icon: FaCalendarAlt,
          route: "https://1404.defadoc.ir",
          target: "_blank",
        },
        {
          name: "راهنما",
          Icon: FaHandsHelping,
          route: appRoutes.guide,
        },
      ],
      [UserRoles.SazmanOstan]: [
        {
          name: "خانه",
          Icon: FaHome,
          route: appRoutes.dashboard,
        },
        {
          name: "صفحه اصلی",
          Icon: FaHome,
          route: "https://defadoc.ir",
          isLink: true,
        },
        {
          name: "حساب کاربری",
          Icon: FaUser,
          route: appRoutes.profile,
        },
        {
          name: "مدیریت کاربران",
          Icon: FaUserFriends,
          route: appRoutes.userList,
        },
        {
          name: "ارتباط‌ با ما",
          Icon: FaFileAlt,
          route: appRoutes.contactUs,
        },
        {
          name: "سابقه سامانه ۱۴۰۴",
          Icon: FaCalendarAlt,
          route: "https://1404.defadoc.ir",
          target: "_blank",
        },
        {
          name: "راهنما",
          Icon: FaHandsHelping,
          route: appRoutes.guide,
        },
      ],
      [UserRoles.ModireKol]: [
        {
          name: "خانه",
          Icon: FaHome,
          route: appRoutes.dashboard,
        },
        {
          name: "صفحه اصلی",
          Icon: FaHome,
          route: "https://defadoc.ir",
          isLink: true,
        },
        {
          name: "حساب کاربری",
          Icon: FaUser,
          route: appRoutes.profile,
        },
        {
          name: "مدیریت کاربران",
          Icon: FaUserFriends,
          route: appRoutes.userList,
        },
        {
          name: "مدیریت شهر ها",
          Icon: FaCity,
          route: appRoutes.cityList,
        },
        {
          name: "مدیریت استان ها",
          Icon: MdOutlineRealEstateAgent,
          route: appRoutes.stateList,
        },
        {
          name: "مدیریت مجموعه ها",
          Icon: MdCollectionsBookmark,
          route: appRoutes.majmooeList,
        },
        {
          name: "مدیریت سازمان ها",
          Icon: GoOrganization,
          route: appRoutes.sazmanList,
        },
        {
          name: "مدیریت مناسبت ها",
          Icon: TbCirclesRelation,
          route: appRoutes.monasebatList,
        },
        {
          name: "مدیریت حوزه ها",
          Icon: MdLocalActivity,
          route: appRoutes.hozeFaaliatList,
        },
        {
          name: "مدیریت برنامه ها",
          Icon: RiMiniProgramFill,
          route: appRoutes.barnameList,
        },
        {
          name: "مدیریت عنوان ها",
          Icon: MdOutlineSubtitles,
          route: appRoutes.onvanList,
        },
        {
          name: "مدیریت موضوع ها",
          Icon: MdOutlineSubject,
          route: appRoutes.mozooList,
        },
        {
          name: "مدیریت گزارش ها ",
          Icon: FaClipboardQuestion,
          route: appRoutes.questionList,
        },
        {
          name: "سابقه سامانه ۱۴۰۴",
          Icon: FaCalendarAlt,
          route: "https://1404.defadoc.ir",
          target: "_blank",
        },
        {
          name: "راهنما",
          Icon: FaHandsHelping,
          route: appRoutes.guide,
        },
      ],
      [UserRoles.Admin]: [
        {
          name: "خانه",
          Icon: FaHome,
          route: appRoutes.dashboard,
        },
        {
          name: "صفحه اصلی",
          Icon: FaHome,
          route: "https://defadoc.ir",
          isLink: true,
        },
        {
          name: "حساب کاربری",
          Icon: FaUser,
          route: appRoutes.profile,
        },
        {
          name: "مدیریت کاربران",
          Icon: FaUserFriends,
          route: appRoutes.userList,
        },
        {
          name: "ارتباط‌ با ما",
          Icon: FaFileAlt,
          route: appRoutes.contactUs,
        },
        {
          name: "سابقه سامانه ۱۴۰۴",
          Icon: FaCalendarAlt,
          route: "https://1404.defadoc.ir",
          target: "_blank",
        },
        {
          name: "راهنما",
          Icon: FaHandsHelping,
          route: appRoutes.guide,
        },
      ],
    },
    [],
  );

  const handleShowMainMenu = () => {
    setShowMenu((c) => !c);
  };

  const [[profile], { loading }] = useApiCall({
    endpoints: ApiEndpoints.user.profile,
  });

  const userProfile = storageApi.useGetUser();

  const isAdmin = () => {
    return (
      userProfile.role == "state_manager" ||
      userProfile.role === "admin" ||
      userProfile.role === "state_organization_manager" ||
      userProfile.role === "organization_manager"
    );
  };

  const onLogoutPress = () => {
    logoutUser();
    navigate(appRoutes.authLogin);
  };

  const goAccount = () => {
    navigate(appRoutes.profile);
  };

  const onItemPress = (item) => {
    if (item.target == "_blank") {
      window.open(item.route, "_blank");
    } else if (!item.isLink) {
      navigate(item.route);
    } else {
      window.open(item.route, "_self");
    }
  };

  const renderMenu = (inSideBar) => {
    return (
      <div
        className={` ${isAdmin() ? "bg-[#05505F]" : "bg-primary-light"} text-white h-[110%] min-h-screen md:w-full w-[80%] md:m-0 m-4 md:rounded-none rounded-lg md:sticky ${showMenu ? "" : "hidden"} md:block top-0 col-span-1 p-8`}
      >
        {!inSideBar && (
          <div onClick={handleShowMainMenu}>
            <IoMenu size={24} />
          </div>
        )}
        <div className="flex flex-col gap-4 items-center">
          <div
            className="h-32 w-32 flex justify-center items-center"
            onClick={() => navigate("/dashboard")}
          >
            <img src={logo} alt="Logo White 1" />
            <img src={logo2} alt="Logo White 2" />
          </div>
        </div>
        {/* main menu */}
        <div className="flex flex-col mt-8">
          {mainMenuItems.map(({ Icon, ...item }, index) => (
            <div
              onClick={() => {
                onItemPress(item);
              }}
              key={index}
              className={`flex gap-1 cursor-pointer p-3 bg-opacity-0 items-center text-white text-sm rounded-lg `}
            >
              <Icon size={24} />
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (showMenu) {
    return renderMenu();
  }

  return (
    <GuardLayout>
      <div className="md:grid grid-cols-5">
        {renderMenu(true)}
        <div className=" col-span-4 bg-white ">
          <div className="header-style shadow-md w-full p-2 gap-4 flex justify-end relative">
            <div
              className="md:hidden absolute top-[50%] -translate-y-[50%] right-8"
              onClick={handleShowMainMenu}
            >
              <IoMenu size={24} />
            </div>
            <div className="md:hidden flex">
              <img src={logo3} className="w-12" alt="Logo Black 1" />
              <img src={logo4} className="w-12" alt="Logo Black 2" />
            </div>
            <div className="flex gap-4">
            </div>
            <div className="flex gap-4">
              <div
                className="cursor-pointer border-2 flex gap-2 text-sm items-center border-gray-100 text-gray-800 py-2 px-4 rounded-md relative"
                onClick={() => setShowProfileDropDown(!showProfileDropDown)}
              >
                {showProfileDropDown && (
                  <div
                    className={
                      "absolute  min-w-full w-[200px] bg-white left-0 md:right-0 top-[100%] z-50 rounded-b-xl p-2 border-gray-300 border"
                    }
                  >
                    <div
                      onClick={goAccount}
                      className={
                        "my-4 flex items-center hover:bg-slate-100 hover:text-slate-800"
                      }
                    >
                      <FaUser className={"mx-2"} />
                      حساب کاربری
                    </div>
                    <div
                      onClick={onLogoutPress}
                      className={
                        "my-4 flex items-center hover:bg-slate-100 hover:text-slate-800"
                      }
                    >
                      <FaSignOutAlt className={"mx-2"} />
                      خروج
                    </div>
                  </div>
                )}
                <div>
                  <FaRegUserCircle size={20} />
                </div>
                <div className="md:inline-block hidden">
                  <span>
                    {userProfile.fullName ?? profile?.data?.fullName} |{" "}
                    {userProfile.phoneNumber ?? profile?.data?.phoneNumber}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {children}
        </div>
      </div>
    </GuardLayout>
  );
};

export default MainLayout;